/**
 * Promotion Service
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LocalTime } from './localTime';


export interface OfferUpdateRequest { 
    code?: string;
    displayName?: string;
    shortDescription?: string;
    kind?: OfferUpdateRequest.KindEnum;
    status?: OfferUpdateRequest.StatusEnum;
    priority?: number;
    stackable?: boolean;
    startDate?: string;
    endDate?: string;
    startTime?: LocalTime;
    endTime?: LocalTime;
    definitionJson?: string;
    salesChannelCodes?: string;
}
export namespace OfferUpdateRequest {
    export const KindEnum = {
        PeriodicDiscount: 'PERIODIC_DISCOUNT',
        Multibuy: 'MULTIBUY',
        TotalDiscount: 'TOTAL_DISCOUNT',
        LineDiscount: 'LINE_DISCOUNT',
        Tender: 'TENDER',
        MixMatch: 'MIX_MATCH',
        PurchaseWithPurchase: 'PURCHASE_WITH_PURCHASE'
    } as const;
    export type KindEnum = typeof KindEnum[keyof typeof KindEnum];
    export const StatusEnum = {
        Draft: 'DRAFT',
        Active: 'ACTIVE',
        Inactive: 'INACTIVE'
    } as const;
    export type StatusEnum = typeof StatusEnum[keyof typeof StatusEnum];
}


